<template>
	<label class="form-field--search"><span class="sr-only" v-html="label"/>
		<input
			:value="value" type="text" @change="onChange" @input="onInput" v-on:keydown.enter.prevent
			v-on:keyup.enter.prevent="onChange"/>
		<button v-if="value.length" @click.prevent="clear()">Clear</button>
	</label>
</template>

<script>
export default {
	name: "FormFieldSearch",
	props: {
		label: {
			type: String,
			default() {
				return "Search";
			},
		},
		value: {
			required: true,
			type: String,
		},
	},
	/* Can add validation here
	watch: {
	  value: {
		handler(newValue, oldValue) {

		},
	  },
	}, */
	methods: {
		onInput(event) {
			// Can add validation here
			this.$emit("input", event.target.value);
		},
		onChange(event) { // Supports .lazy
			// Can add validation here
			this.$emit("change", event.target.value);
		},
		clear() {
			this.$emit("input", "");
			this.$emit("change", "");
		},
	},
};
</script>
